import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { baseUrlApiManagement } from "../../services/data/axios-base";

interface StartupErrorScreenProps {
  onRetry: () => void;
  isRetrying: boolean;
}

/**
 * Shown when the frontend params request fails, i.e. the backend could not be reached
 * at all. Without it the app renders nothing in this state, which on the Android app
 * looks like a permanently white screen with no hint of what went wrong.
 */
const StartupErrorScreen: React.FC<StartupErrorScreenProps> = ({ onRetry, isRetrying }) => {
  const { t } = useTranslation();

  return (
    <Stack height="100%" alignItems="center" justifyContent="center" spacing={3} padding={4} textAlign="center">
      <Typography variant="h6">{t("error-loading-content")}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ wordBreak: "break-all" }}>
        {baseUrlApiManagement}
      </Typography>
      <Button variant="contained" onClick={onRetry} disabled={isRetrying}>
        {isRetrying ? <CircularProgress size={24} color="inherit" /> : t("button-refresh")}
      </Button>
    </Stack>
  );
};

export default StartupErrorScreen;
